import { Filter } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { DatePickerWithPresets } from "@/shared/components/range-picker/RangePicker";
import { DynamicSelectFilter } from "@/shared/components/filters/Filters";
import type { DictionariesResponse } from "../types";
import type { Airport, SystemDictionary } from "@/shared/api/filters";
import type { FlightsFiltersState } from "../pages/MarkupsPage";

interface FlightsDictionary {
  airlines: { code: string; label: string }[];
  statuses: { code: string; label: string }[];
  flightTypes: { code: string; label: string }[];
}

interface FlightsFiltersProps {
  totalCount: number;
  filteredCount: number;
  filters: FlightsFiltersState;
  setFilters: React.Dispatch<React.SetStateAction<FlightsFiltersState>>;
  dictionary: SystemDictionary | undefined;
  airports: Airport[];
}

export function FlightsFilters({
  totalCount,
  filteredCount,
  dictionary,
  filters,
  setFilters,
  airports,
}: FlightsFiltersProps) {
  if (!dictionary) return null;

  const updateFilter = (key: string, value: string) => {
    // Если выбрали "all", сбрасываем фильтр (передаем пустую строку)
    setFilters((prev) => ({ ...prev, [key]: value === "all" ? "" : value }));
  };

  const handleDateChange = (dateFrom: string, dateTo: string) => {
    setFilters((prev) => ({ ...prev, dateFrom, dateTo, page: 1 }));
  };

  const resetFilters = () => {
    setFilters({
      airline: "",
      page: 1,
      pageSize: 20,
      dateFrom: "",
      dateTo: "",
      toIata: "",
      fromIata: "",
      isManual: "",
    });
  };

  return (
    <div className="bg-white rounded-t-lg border p-4">
      <div className="flex flex-wrap items-center gap-3">
        <Filter className="w-5 h-5 text-gray-500" />

        <DatePickerWithPresets
          dateFrom={filters.dateFrom}
          dateTo={filters.dateTo}
          onChange={handleDateChange}
        />

        {/* 1. Пример с массивом простых строк (airlines) */}
        <DynamicSelectFilter
          placeholder="Авиакомпания"
          data={dictionary.airlines}
          value={filters.airline || undefined}
          onChange={(val) => updateFilter("airline", val)}
          // Для простых строк value и label одинаковые
          valueExtractor={(item) => item}
          labelExtractor={(item) => item}
        />

        <DynamicSelectFilter
          placeholder="Тип рейса"
          data={dictionary.flight_types}
          value={filters.isManual || undefined}
          onChange={(val) => updateFilter("isManual", val)}
          valueExtractor={(item) => item.code}
          labelExtractor={(item) => item.label}
        />
        {/* <DynamicSelectFilter
                 placeholder="Статус"
                 data={dictionary.order_statuses}
                 value={filters.status || undefined}
                 onChange={(val) => updateFilter("status", val)}
                 valueExtractor={(item) => item.code}
                 labelExtractor={(item) => item.label}
               />
               <DynamicSelectFilter
                 placeholder="Статус оплаты"
                 data={dictionary.payment_statuses}
                 value={filters.paymentStatus || undefined}
                 onChange={(val) => updateFilter("paymentStatus", val)}
                 valueExtractor={(item) => item.code}
                 labelExtractor={(item) => item.label}
               /> */}
        <DynamicSelectFilter
          placeholder="Вылет"
          searchPlaceholder="Поиск по аэропорту..."
          data={airports}
          value={filters.fromIata || undefined}
          onChange={(val) => updateFilter("fromIata", val)}
          valueExtractor={(item) => item.IATA}
          labelExtractor={(item) => `${item.IATA} — ${item.City.ru}`}
        />
        <DynamicSelectFilter
          placeholder="Прилет"
          searchPlaceholder="Поиск по аэропорту..."
          data={airports}
          value={filters.toIata || undefined}
          onChange={(val) => updateFilter("toIata", val)}
          valueExtractor={(item) => item.IATA}
          labelExtractor={(item) => `${item.IATA} — ${item.City.ru}`}
        />

        <Button
          variant="ghost"
          size="sm"
          className="h-10"
          onClick={resetFilters}
        >
          Сброс фильтров
        </Button>
      </div>
    </div>
  );
}
